import React, { useMemo } from "react";
import { useLocation } from "react-router-dom";
import DocumentationLayout from "../../components/dashboard/common/Documentation/DocumentationLayout";

const OnboardingDocumentation = () => {
  const { pathname } = useLocation();

  const sidebarItems = useMemo(() => [
    { title: "Introduction", href: "/dashboard/onboarding-documentation", isHeader: false },
    { title: "Interactive Tour", href: "/dashboard/onboarding-documentation#interactive-tour" },
    { title: "Overview", href: "/dashboard/onboarding-documentation#overview" },
    { title: "Platform Tiers", href: "/dashboard/onboarding-documentation#platform-tiers" },
    
    { title: "Guided Steps", href: "", isHeader: true },
    { title: "Step 1: Asset Inventory", href: "/dashboard/onboarding-documentation/asset-inventory" },
    { title: "Step 2: Scoping & Targets", href: "/dashboard/onboarding-documentation/scoping" },
    { title: "Step 3: Endpoint Discovery", href: "/dashboard/onboarding-documentation/endpoint-discovery" },
    { title: "Step 4: Credential Vault", href: "/dashboard/onboarding-documentation/credential-vault" },
    { title: "Step 5: Program Deployment", href: "/dashboard/onboarding-documentation/program-engineering" },
    { title: "Step 6: Runs & Quota", href: "/dashboard/onboarding-documentation/scheduled-runs" },
    { title: "Step 7: Verification", href: "/dashboard/onboarding-documentation/snapshot-verification" },
  ], []);

  const tocItemsByPath: Record<string, { id: string; title: string }[]> = {
    "/dashboard/onboarding-documentation": [
      { id: "interactive-tour", title: "Interactive Tour" },
      { id: "overview", title: "Overview" },
      { id: "platform-tiers", title: "Platform Tiers" },
    ],
    "/dashboard/onboarding-documentation/asset-inventory": [
      { id: "identity-ownership", title: "1.1 Identity & Ownership" },
      { id: "lifecycle-usage", title: "1.2 Lifecycle & Usage" },
      { id: "classification-criticality", title: "1.3 Classification & Criticality" },
      { id: "data-privacy", title: "1.4 Data & Privacy" },
      { id: "access-control", title: "1.5 Access Control" },
      { id: "security-testing", title: "1.6 Security Testing Focus" },
      { id: "governance-attestation", title: "1.7 Governance & Attestation" },
    ],
    "/dashboard/onboarding-documentation/scoping": [
      { id: "template-types", title: "2.1 Template Types" },
      { id: "required-fields", title: "2.2 Required Fields" },
      { id: "bulk-import", title: "2.3 Bulk Import" },
    ],
    "/dashboard/onboarding-documentation/endpoint-discovery": [
      { id: "resource-types", title: "3.1 Resource Types" },
      { id: "scope-states", title: "3.2 Scope States" },
      { id: "entry-methods", title: "3.3 Entry Methods" },
      { id: "researcher-discovery", title: "3.4 Researcher Discovery" },
    ],
    "/dashboard/onboarding-documentation/credential-vault": [
      { id: "encryption", title: "4.1 Encryption" },
      { id: "credential-types", title: "4.2 Credential Types" },
    ],
    "/dashboard/onboarding-documentation/program-engineering": [
      { id: "scheduling", title: "5.1 Scheduling" },
      { id: "wizard", title: "5.2 Deployment Wizard" },
      { id: "safety-checks", title: "5.3 Safety Checks" },
    ],
    "/dashboard/onboarding-documentation/scheduled-runs": [
      { id: "run-types", title: "6.1 Run Types" },
      { id: "lifecycle", title: "6.2 Lifecycle States" },
      { id: "quota", title: "6.3 Quota Management" },
    ],
    "/dashboard/onboarding-documentation/snapshot-verification": [
      { id: "workflow", title: "7.1 Verification Workflow" },
      { id: "inventory-sync", title: "7.2 Inventory Sync" },
      { id: "target-exclusion", title: "7.3 Target Exclusion" },
    ],
  };

  const breadcrumbsByPath: Record<string, { label: string; href?: string }[]> = {
    "/dashboard/onboarding-documentation": [
      { label: "Docs", href: "/dashboard/onboarding-documentation" },
      { label: "Introduction" }
    ],
    "/dashboard/onboarding-documentation/asset-inventory": [
      { label: "Docs", href: "/dashboard/onboarding-documentation" },
      { label: "Step 1: Asset Inventory" }
    ],
    "/dashboard/onboarding-documentation/scoping": [
      { label: "Docs", href: "/dashboard/onboarding-documentation" },
      { label: "Step 2: Scoping" }
    ],
    "/dashboard/onboarding-documentation/endpoint-discovery": [
      { label: "Docs", href: "/dashboard/onboarding-documentation" },
      { label: "Step 3: Endpoint Discovery" }
    ],
    "/dashboard/onboarding-documentation/credential-vault": [
      { label: "Docs", href: "/dashboard/onboarding-documentation" },
      { label: "Step 4: Credential Vault" }
    ],
    "/dashboard/onboarding-documentation/program-engineering": [
      { label: "Docs", href: "/dashboard/onboarding-documentation" },
      { label: "Step 5: Program Engineering" }
    ],
    "/dashboard/onboarding-documentation/scheduled-runs": [
      { label: "Docs", href: "/dashboard/onboarding-documentation" },
      { label: "Step 6: Scheduled Runs" }
    ],
    "/dashboard/onboarding-documentation/snapshot-verification": [
      { label: "Docs", href: "/dashboard/onboarding-documentation" },
      { label: "Step 7: Snapshot Verification" }
    ],
  };

  const currentPath = pathname.replace(/\/$/, ""); // Normalize path
  const tocItems = tocItemsByPath[currentPath] || [];
  const breadcrumbs = breadcrumbsByPath[currentPath] || breadcrumbsByPath["/dashboard/onboarding-documentation"];

  return (
    <DocumentationLayout
      sidebarItems={sidebarItems}
      tocItems={tocItems}
      breadcrumbs={breadcrumbs}
    />
  );
};

export default OnboardingDocumentation;
